"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var classNames = function (className) {
    var classes = className instanceof Array ? className : [className];
    var classStr = ramda_1.flatten(classes).filter(Boolean).join(' ');
    return classStr === '' ? undefined : classStr;
};
exports["default"] = classNames;
//# sourceMappingURL=classNames.js.map